import { Component, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ElementControlService } from '@src/app/core/services/element-control.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AppConfig, BaseComponent, UserProfileService } from 'sigv-library';
import { isNullOrEmpty } from 'sigv-library/util';
import { PasswordService } from 'src/app/core/services/password.service';

@Component({
  selector: 'sigv-password-change-form',
  templateUrl: './password-change-form.component.html',
  styleUrls: ['./password-change-form.component.scss'],
})
export class PasswordChangeFormComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @Output() changePasswordResult = new EventEmitter<boolean>();
  @ViewChild(RecaptchaComponent) recaptcha?: RecaptchaComponent;

  currentPassword = '';
  newPassword = '';
  confirmPassword = '';
  recaptchaToken = '';

  //是否顯示google驗證圖形
  elementControlJSON = {
    Login: {
      GoogleReCaptcha: {
        display: false,
      },
    },
  };

  private readonly destroy$ = new Subject();

  constructor(
    injector: Injector,
    private userProfileService: UserProfileService,
    private passwordService: PasswordService,
    private elementControlService: ElementControlService
  ) {
    super(injector);
  }

  get envConfig(): any {
    return AppConfig.envConfig;
  }

  ngOnInit(): void {
    //取得是否顯示google驗證圖形
    this.elementControlService
      .getElementControl()
      .pipe(takeUntil(this.destroy$))
      .subscribe((elementControlJSON) => {
        if (isNullOrEmpty(elementControlJSON) === false) {
          this.elementControlJSON = elementControlJSON;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFormSubmit(form: NgForm): void {
    form.form.markAllAsTouched();
    if (form.invalid) {
      return;
    }

    this.passwordService
      .changePassword({
        account: this.userProfileService.currentUserValue?.userNo ?? '',
        currentPassword: this.passwordService.getEncryptedData(this.currentPassword),
        newPassword: this.passwordService.getEncryptedData(this.newPassword),
        recaptchaToken: this.recaptchaToken,
      })
      .pipe(
        takeUntil(this.destroy$),
        map((resp) => (resp?.rtnCode === 0 ? true : false))
      )
      .subscribe((result) => {
        this.changePasswordResult.emit(result);
        this.recaptcha?.reset();
        form.reset();
      });
  }

  onClearBtnClick(form: NgForm): void {
    form.reset();
  }

  onRecaptchaError(event: any): void {
    this.logger.warn('reCAPTCHA error encountered', event);
  }
}

